<template>
  <LayoutId>
    <gdlFormDSL
      :fields="fields"
      :init-data="resource.one"

      readonly
    />
  </LayoutId>
</template>

<script>
import { get, keyBy } from 'lodash';

import pageComponent from '@/mixins/page-component';

import gdlFormDSL from '@/components/gdl/FormDSL.vue';
import LayoutId from './layouts/LayoutId.vue';

export default {
  name: 'RestResourcesIdPage',
  components: { LayoutId, gdlFormDSL },
  mixins: [pageComponent],
  inject: ['config'],
  props: {
    id: { type: String, required: true },
  },
  metaInfo() {
    const { title } = this.$pageComponentRoute.meta;
    const label = get(this.resource.one, this.config.route.key);
    return label ? { title: this.$t(title, { label }) } : { title: '...' };
  },
  breadcrumb() {
    const { breadcrumb } = this.$pageComponentRoute.meta;
    const label = get(this.resource.one, this.config.route.key);
    return {
      label: label ? this.$t(breadcrumb.i18n, { label }) : '',
      loading: !label,
    };
  },
  data() {
    const { fields } = this.config.form;
    return {
      fields,
    };
  },
  computed: {
    $page() { return `${this.config.store.namespace}/${this.id}`; },
    namespace() { return `${this.config.store.namespace}/${this.id}`; },
    resource() { return get(this.$store.state, this.namespace.split('/')); },
    versions() { return get(this.$store.state, [...this.namespace.split('/'), 'Versions']); },
    fieldsBy() { return keyBy(this.fields, 'name'); },
  },
  watch: {
    'resource.one': { handler: 'onResourceChange', immediate: true },
  },
  methods: {
    fetchResource() { this.$store.dispatch(`${this.namespace}/fetchResource`); },
    fetchVersions() { this.$store.dispatch(`${this.namespace}/Versions/fetchResources`); },
    async fetchData() {
      try {
        // await this.fetchVersions();
      } catch (e) {
        throw e;
      }
    },
    onResourceChange() {
      if (!this.resource.one) return;
      this.setTabTitle();
      this.fetchData();
    },
    setTabTitle() {
      // if (!this.$pageComponentRoute) return {};
      const { tab } = this.$pageComponentRoute.meta;
      const label = get(this.resource.one, this.config.route.key);
      if (!label) return;
      this.$store.dispatch('App/TabsBar/updateTab', {
        key: this.$pageComponentKey,
        label: this.$t(tab.i18n, { label }),
        loading: false,
      });
    },
  },
};
</script>
